import { 
  Button, 
  Box, 
  Typography, 
  Stack,
  useMediaQuery,
  useTheme,
  CircularProgress,
} from '@mui/material';
import EnrollmentListTable from 'components/Moderator/enrollsList/EnrollsList';
import { useEffect, useState } from 'react';
import './styles.css';
import { useLogin } from 'Contexts/AuthProvider/AuthProvider';
import { ipayNet, newServer } from 'constants/constants';
import EnrollItem from 'components/Moderator/EnrollItem';
import { ArrowBack, ArrowForward } from '@mui/icons-material';

const Backoffice = () => {
  const { user, logout } = useLogin();
  const [currentEnrrol, setCurrentEnrrol] = useState();
  const [enrolls, setEnrolls] = useState<any>([]);
  const [requestInfo, setRequestInfo] = useState();
  const [page, setpage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(20);
  const [loading, setLoading] = useState<boolean>(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (user?.token) {
      fetchEnrollments(page);
    }
  }, [user]);

  const fetchEnrollments = async (page: number) => {
    setLoading(true);
    try {
      const response = await fetch(`${newServer}requests/1?page=${page}&limit=${limit}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user?.token}`,
          'x-api-key': ipayNet.apiToken,
        },
      });

      try {
        const res = await response.json();

        if (res.message === 'Access denied') {
          logout();
          return;
        }
        setRequestInfo(res?.data);
        setEnrolls(res?.data?.map((item: any) => ({ ...item.info_dwolla, id: item.id })));
        return;
      } catch (error) {
        if (response.status === 200) {
          return response;
        }
        console.error(JSON.stringify(error));
      }
    } catch (error) {
      console.error(JSON.stringify(error));
    } finally {
      setLoading(false);
    }
  };

  const paginateContent = (page: number) => {
    setpage(page);
    fetchEnrollments(page);
  };

  const goBack = () => {
    setCurrentEnrrol(undefined);
    fetchEnrollments(page);
  };

  return (
    <Box sx={{ 
      bgcolor: '#f8fafc',
      p: { xs: 1.5, sm: 2, md: 3 },
    }}>
      {loading ? (
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '50vh',
          gap: 2,
        }}>
          <CircularProgress sx={{ color: '#E91E8C' }} size={48} />
          <Typography variant="body2" sx={{ color: '#64748b' }}>
            Loading requests...
          </Typography>
        </Box>
      ) : !currentEnrrol && enrolls && (
        <Box>
          <Box sx={{ 
            bgcolor: 'white',
            borderRadius: 2,
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            border: '1px solid #e2e8f0',
            overflow: 'hidden',
          }}>
            <EnrollmentListTable
              data={enrolls}
              requestInfo={requestInfo}
              onApprove={function (index: number): void {}}
              onDeny={function (index: number): void {}}
              setCurrentEnrrol={setCurrentEnrrol}
            />
          </Box>

          <Stack 
            direction="row" 
            alignItems="center" 
            justifyContent="center"
            spacing={1.5}
            sx={{ mt: 2 }}
          >
            <Button
              variant="outlined"
              size="small"
              onClick={() => paginateContent(page - 1)}
              disabled={page === 1}
              startIcon={<ArrowBack sx={{ fontSize: '0.9rem' }} />}
              sx={{
                borderColor: '#e2e8f0',
                color: '#64748b',
                fontSize: '0.75rem',
                py: 0.75,
                '&:hover': {
                  borderColor: '#E91E8C',
                  color: '#E91E8C',
                  bgcolor: '#fdf2f8',
                },
                '&:disabled': {
                  borderColor: '#e2e8f0',
                  color: '#cbd5e1',
                },
              }}
            >
              {isMobile ? '' : 'Previous'}
            </Button>
            
            <Box sx={{ 
              px: 2, 
              py: 0.5, 
              bgcolor: '#1e293b', 
              borderRadius: 1.5,
              color: 'white',
              fontWeight: 600,
              fontSize: '0.8rem',
            }}>
              {page}
            </Box>
            
            <Button
              variant="contained"
              size="small"
              onClick={() => paginateContent(page + 1)}
              endIcon={<ArrowForward sx={{ fontSize: '0.9rem' }} />}
              sx={{
                bgcolor: '#1e293b',
                fontSize: '0.75rem',
                py: 0.75,
                '&:hover': { bgcolor: '#E91E8C' },
              }}
            >
              {isMobile ? '' : 'Next'}
            </Button>
          </Stack>
        </Box>
      )}
          
      {currentEnrrol && (
        <EnrollItem
          data={currentEnrrol as any}
          goBack={goBack}
        />
      )}
    </Box>
  );
};

export default Backoffice;
